module.exports = __webpack_public_path__ + "static/media/video.de98f190.svg";